import React from "react";
import { Controller } from "react-hook-form";
import { FieldProp } from "../model/FieldProp";
import { TextModel } from "../../../businessFoundation/Primitives/TextManage/TextModel";
import { TextField as TextFieldEP } from "@episerver/ui-framework";

const TextField: React.FC<FieldProp<any>> = (props) => {
    const { index, property, control, errors } = props;
    const validationData = property.validationData as TextModel;

    return (
        <Controller
            name={`extendedProperties[${index}].value`}
            control={control}
            rules={{
                required: {
                    value: !property.isNullable,
                    message: `${property.friendlyName} is required`,
                },
            }}
            render={({ field: { onChange, value } }) => (
                <TextFieldEP
                    id={`extendedProperties[${index}].value`}
                    type="text"
                    maxLength={parseInt(validationData.maxLength.toString())}
                    outlined
                    label={property.friendlyName}
                    helperText={errors.extendedProperties ? errors.extendedProperties[index]?.value?.message ?? property.description : property.description}
                    invalid={errors.extendedProperties && errors.extendedProperties[index]?.value ? true : false}
                    value={value ?? ""}
                    onChange={onChange}
                />
            )}
        />
    );
};

export default TextField;
